module.exports = __webpack_public_path__ + "static/img/card.4f898584.jpg";